if (!window.__ashanartStoreScriptLoaded) {
  window.__ashanartStoreScriptLoaded = true;
/**
 * Ashana Art - Front-End Store Foundation
 * This file handles UI interactions, fake cart state (for phase 1), 
 * and sets up architecture for future backend integration.
 */

// STATE MANAGEMENT (Future-ready architecture)
// In a real e-commerce store, this state would map to local storage / backend database.
const StoreState = {
    cart: [],
    currency: '$',
    
    // Future expansion hooks
    user: null,
    locale: 'en-US' // Future i18n
};

// UI CONTROLLERS
const UI = {
    init() {
        this.setupPreloader();
        this.setupAnimations();
        this.setupCartInteractions();
        this.setupCheckoutForm();
        this.setupCatalogFilters();
        this.updateCartUI();
    },

    // Preloader Logic
    setupPreloader() {
        const preloader = document.getElementById('preloader');
        if (!preloader) return;
        
        // Wait for page to fully load
        window.addEventListener('load', () => {
            // Keep it visible for a moment so the loading video plays gracefully
            setTimeout(() => {
                preloader.classList.add('hidden');
            }, 2000);
        });
    },

    // 1. Soft Fade-in visual effects (Intersection Observer)
    setupAnimations() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                }
            });
        }, { threshold: 0.1 });

        document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));
        
        // Trigger for elements immediately in view (header, hero)
        setTimeout(() => {
            document.querySelectorAll('.fade-in').forEach(el => {
                const rect = el.getBoundingClientRect();
                if(rect.top < window.innerHeight) {
                    el.classList.add('is-visible');
                }
            });
        }, 100);
    },

    // Catalog Filter Logic
    setupCatalogFilters() {
        const filterBtns = document.querySelectorAll('.filter-btn');
        if (filterBtns.length === 0) return;

        filterBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                // Update active button styles
                filterBtns.forEach(b => {
                    b.classList.remove('btn-primary');
                    b.classList.add('btn-outline');
                });
                const clickedBtn = e.target;
                clickedBtn.classList.remove('btn-outline');
                clickedBtn.classList.add('btn-primary');

                // Filter items
                const filterValue = clickedBtn.getAttribute('data-filter');
                const products = document.querySelectorAll('#fullCatalogGrid .product-card');

                products.forEach(product => {
                    const categoryEl = product.querySelector('.category');
                    if (!categoryEl) return;
                    
                    const catText = categoryEl.innerText.trim();

                    if (filterValue === 'all' || catText === filterValue) {
                        product.style.display = 'block';
                        // Re-trigger fade-in animation slightly for visual polish
                        product.classList.remove('is-visible');
                        setTimeout(() => product.classList.add('is-visible'), 10);
                    } else {
                        product.style.display = 'none';
                    }
                });
            });
        });
    },

    // 2. Cart logic placeholder
    setupCartInteractions() {
        const addButtons = document.querySelectorAll('.add-to-cart-btn');
        
        addButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const card = e.target.closest('.product-card');
                const id = card.getAttribute('data-id');
                const title = card.querySelector('.product-title').innerText;
                const price = parseFloat(card.getAttribute('data-price'));

                this.addToCart({ id, title, price, quantity: 1 });
            });
        });
    },

    addToCart(product) {
        // Check if item exists
        const existing = StoreState.cart.find(item => item.id === product.id);
        if (existing) {
            existing.quantity += 1;
        } else {
            StoreState.cart.push(product);
        }

        // Visual feedback
        const btn = document.querySelector(`.product-card[data-id="${product.id}"] .add-to-cart-btn`);
        if (btn) {
            const originalText = btn.innerText;
            btn.innerText = 'Added!';
            btn.style.backgroundColor = 'var(--primary-color)';
            btn.style.color = 'white';
            setTimeout(() => {
                btn.innerText = originalText;
                btn.style.backgroundColor = 'transparent';
                btn.style.color = 'var(--primary-color)';
            }, 1500);
        }

        this.updateCartUI();
    },

    updateCartUI() {
        // Update Cart Header Count
        const countSpan = document.getElementById('cart-count');
        const totalItems = StoreState.cart.reduce((sum, item) => sum + item.quantity, 0);
        if (countSpan) countSpan.innerText = totalItems;

        // Update Checkout Order Summary Preview
        const summaryContainer = document.getElementById('summary-items');
        const subtotalEl = document.getElementById('summary-subtotal');
        const totalEl = document.getElementById('summary-total');

        if (!summaryContainer) return; // Not on checkout view

        if (StoreState.cart.length === 0) {
            summaryContainer.innerHTML = '<p class="empty-cart-msg">Your cart is empty.</p>';
            subtotalEl.innerText = `${StoreState.currency}0.00`;
            totalEl.innerText = `${StoreState.currency}0.00`;
            return;
        }

        let html = '';
        let subtotal = 0;

        StoreState.cart.forEach(item => {
            const itemTotal = item.price * item.quantity;
            subtotal += itemTotal;
            html += `
                <div class="summary-item-row">
                    <span>${item.quantity}x ${item.title}</span>
                    <span>${StoreState.currency}${itemTotal.toFixed(2)}</span>
                </div>
            `;
        });

        summaryContainer.innerHTML = html;
        subtotalEl.innerText = `${StoreState.currency}${subtotal.toFixed(2)}`;
        // For now total is subtotal (Shipping calc hook would go here)
        totalEl.innerText = `${StoreState.currency}${subtotal.toFixed(2)}`;
    },

    // 3. Checkout Form Validation Hook
    setupCheckoutForm() {
        const form = document.getElementById('checkoutForm');
        if (!form) return;

        form.addEventListener('submit', (e) => {
            e.preventDefault();

            // FUTURE PAYMENT GATEWAY BOUNDARY
            // At this point, real payment methods (Stripe, PayPal, etc) would tokenize elements
            if (StoreState.cart.length === 0) {
                alert("Your cart is empty. Please add products before checking out.");
                return;
            }

            console.log("--- SECURE CHECKOUT INITIATED ---");
            console.log("Customer: ", document.getElementById('email').value);
            console.log("Cart payload: ", StoreState.cart);

            alert("Thank you! This is a phase-1 visual checkout. In the future, this will connect to the backend server to process the payment and shipping securely.");
        });
    }
};

// Initialize Application
document.addEventListener('DOMContentLoaded', () => {
    UI.init();
});

}

document.addEventListener('DOMContentLoaded', function () {
  if(document.documentElement.dataset.aaVersion==='03')return;
  if (window.location.pathname !== '/pages/customize-tumbler') return;
  window.setTimeout(function () {
    var size = document.getElementById('aa-size');
    var lid = document.getElementById('aa-lid');
    var preview = document.getElementById('aa-preview');
    var price = document.getElementById('aa-price');
    var badge = document.getElementById('aa-badge');
    if (!size || !lid || !preview || !price || !badge) return;

    var products = {
      '12': { price: 29.99, id: '52823447568669', image: 'https://cdn.shopify.com/s/files/1/1007/4901/7373/files/ashanart-customizer-12oz-v09.png?v=1792641065' },
      '16': { price: 29.99, id: '52897156858141', image: 'https://cdn.shopify.com/s/files/1/1007/4901/7373/files/ashanart-customizer-16oz-v11.png?v=1792642774' },
      '24': { price: 34.99, id: '52897156890909', image: 'https://cdn.shopify.com/s/files/1/1007/4901/7373/files/ashanart-customizer-24oz-v09.png?v=1792641056' },
      '30': { price: 36.99, id: '67733755953437', image: 'https://cdn.shopify.com/s/files/1/1007/4901/7373/files/ashanart-customizer-30oz-v09.png?v=1792641072' },
      '20': { price: 38.99, id: '52823447994653', image: 'https://cdn.shopify.com/s/files/1/1007/4901/7373/files/ashanart-customizer-20oz-v09.png?v=1792641048' }
    };

    if (!size.querySelector('option[value="30"]')) {
      var option = document.createElement('option');
      option.value = '30';
      option.textContent = 'Snowglobe Acrylic Tumbler · 30 oz';
      size.insertBefore(option, size.querySelector('option[value="20"]'));
    }

    function syncDraftPreview() {
      var product = products[size.value];
      if (!product) return;
      preview.src = product.image;
      preview.alt = size.options[size.selectedIndex].text;
      price.textContent = '$' + (product.price + Number(lid.value || 0)).toFixed(2);
      badge.textContent = size.options[size.selectedIndex].text + ' · VISTA DEL PRODUCTO';
    }

    size.addEventListener('change', syncDraftPreview);
    lid.addEventListener('change', syncDraftPreview);
    syncDraftPreview();

    var add = document.getElementById('aa-add');
    if (!add || add.dataset.draftProductMapping === 'true') return;
    add.dataset.draftProductMapping = 'true';
    add.addEventListener('click', function () {
      var originalFetch = window.fetch;
      var selected = products[size.value];
      if (!selected) return;
      window.fetch = function (url, options) {
        if (url === '/cart/add.js' && options && options.body instanceof FormData) {
          options.body.set('id', selected.id);
          window.setTimeout(function () { window.fetch = originalFetch; }, 0);
        }
        return originalFetch.apply(this, arguments);
      };
    }, true);
  }, 0);
});


document.addEventListener('DOMContentLoaded', function () {
  if(document.documentElement.dataset.aaVersion==='03')return;
  if (window.location.pathname !== '/pages/customize-tumbler') return;
  if (document.getElementById('aa-draft-gold-accents')) return;
  var style = document.createElement('style');
  style.id = 'aa-draft-gold-accents';
  style.textContent = [
    '.aa-customizer{--gold:#d4b371;--gold-soft:#f3d79e;--gold-deep:#9d7639;}',
    '.aa-customizer .aa-kicker{color:var(--gold);}',
    '.aa-customizer .aa-preview,.aa-customizer .aa-form{border-color:rgba(212,179,113,.58);}',
    '.aa-customizer .aa-stage{background:radial-gradient(circle at 50% 20%,#6b5134 0%,#34291e 52%,#191511 100%);}',
    '.aa-customizer .aa-badge{border-color:rgba(243,215,158,.72);color:#fff1d2;background:rgba(58,42,24,.9);}',
    '.aa-customizer .aa-price{border-color:rgba(212,179,113,.58);box-shadow:inset 3px 0 0 var(--gold);}',
    '.aa-customizer .aa-price strong{color:var(--gold-soft);}',
    '.aa-customizer input:focus,.aa-customizer select:focus,.aa-customizer textarea:focus{outline-color:rgba(212,179,113,.52);border-color:var(--gold);}',
    '.aa-customizer .aa-optional{color:var(--gold-soft);border-color:rgba(212,179,113,.7);background:rgba(212,179,113,.1);}',
    '.aa-customizer .aa-upload{border-color:var(--gold)!important;color:#f7dfae;transition:background .2s ease,border-color .2s ease;}',
    '.aa-customizer .aa-upload:hover{background:rgba(212,179,113,.12);border-color:#f3d79e!important;}',
    '.aa-customizer .aa-add{background:linear-gradient(110deg,#f2dca2,#aa8040);color:#251b12;box-shadow:0 12px 24px rgba(119,81,29,.28);}',
    '.aa-customizer .aa-add:hover:not(:disabled){filter:brightness(1.08);transform:translateY(-1px);}',
    '.aa-customizer .aa-divider{background:linear-gradient(90deg,transparent,rgba(212,179,113,.72),transparent);}',
    '.aa-customizer .aa-status.ok{background:#e6e4cf;color:#375035;}',
    '.aa-customizer .aa-status.err{background:#f0dfc7;color:#6f3c20;}'
  ].join('');
  document.head.appendChild(style);
});


document.addEventListener('DOMContentLoaded', function () {
  if(document.documentElement.dataset.aaVersion==='03')return;
  if (document.getElementById('aa-draft-global-halo')) return;
  var style = document.createElement('style');
  style.id = 'aa-draft-global-halo';
  style.textContent = [
    'html{background:#211d19;}',
    'body{min-height:100vh;background:radial-gradient(ellipse 75% 42% at 14% 7%,rgba(212,179,113,.16) 0%,rgba(212,179,113,.07) 35%,transparent 72%),radial-gradient(ellipse 65% 38% at 88% 31%,rgba(184,137,69,.13) 0%,rgba(184,137,69,.05) 43%,transparent 76%),linear-gradient(155deg,#25201b 0%,#1d1a17 52%,#211c19 100%);background-attachment:fixed;}',
    'body:before{content:"";position:fixed;inset:0;pointer-events:none;z-index:-1;background:radial-gradient(ellipse 46% 22% at 50% 100%,rgba(157,118,57,.08),transparent 80%);}',
    '.aa-global-nav{background:linear-gradient(90deg,rgba(39,30,24,.96),rgba(48,35,25,.96))!important;border-bottom-color:rgba(212,179,113,.28)!important;}',
    '.aa-global-nav:after{content:"";position:absolute;left:10%;right:10%;bottom:-1px;height:1px;background:linear-gradient(90deg,transparent,rgba(212,179,113,.72),rgba(184,137,69,.62),transparent);}',
    '.aa-global-nav__brand,.aa-global-nav__links a,.aa-global-products__trigger{color:#f3ddc4!important;}',
    '.aa-global-nav__sub{color:#d7b7a4!important;}'
  ].join('');
  document.head.appendChild(style);
});


document.addEventListener('DOMContentLoaded', function () {
  if(document.documentElement.dataset.aaVersion==='03')return;
  if (document.getElementById('aa-draft-unified-navigation')) return;
  var style = document.createElement('style');
  style.id = 'aa-draft-unified-navigation';
  style.textContent = [
    '.navbar,.aa-global-nav,.shopify-section-group-header-group,.shopify-section-group-header-group > *,header.header{position:relative;}',
    '.navbar,.aa-global-nav,.shopify-section-group-header-group,.shopify-section-group-header-group > *,header.header{background:linear-gradient(100deg,rgba(37,28,23,.98),rgba(61,43,27,.97))!important;border-color:rgba(212,179,113,.38)!important;box-shadow:0 8px 28px rgba(13,8,11,.25),inset 0 -1px rgba(243,215,158,.08)!important;}',
    '.navbar:after,.aa-global-nav:after,.shopify-section-group-header-group:after,header.header:after{content:"";position:absolute;left:7%;right:7%;bottom:-1px;height:1px;background:linear-gradient(90deg,transparent,rgba(212,179,113,.78),rgba(232,193,116,.74),transparent);pointer-events:none;}',
    '.navbar .brand,.navbar .brand span,.navbar .nav-links a,.navbar .nav-links button,.navbar .cart-toggle,.navbar .aa-menu-button,.shopify-section-group-header-group a,.shopify-section-group-header-group button,header.header a,header.header button{color:#f8e5d2!important;}',
    '.navbar .nav-links a:hover,.navbar .nav-links button:hover,.navbar .cart-toggle:hover,.shopify-section-group-header-group a:hover,.shopify-section-group-header-group button:hover,header.header a:hover,header.header button:hover{color:#f2d18b!important;}',
    '.navbar .aa-menu-button,.navbar .aa-mobile-lang,.shopify-section-group-header-group .header-actions__action,header.header .header-actions__action{border-color:rgba(212,179,113,.58)!important;background:rgba(255,255,255,.04)!important;}',
    '.navbar .aa-menu-button span{background:#f2d18b!important;}',
    '@media(max-width:768px){.navbar .aa-mobile-menu-panel{background:#2b251f!important;border-color:rgba(212,179,113,.5)!important;}.navbar .aa-mobile-menu-panel a{color:#f8e5d2!important;border-bottom-color:rgba(212,179,113,.2)!important;}}'
  ].join('');
  document.head.appendChild(style);
});


document.addEventListener('DOMContentLoaded', function () {
  if(document.documentElement.dataset.aaVersion==='03')return;
  if (document.getElementById('aa-draft-visible-halo')) return;
  var style = document.createElement('style');
  style.id = 'aa-draft-visible-halo';
  style.textContent = [
    'body{position:relative;isolation:isolate;}',
    'body:after{content:"";position:fixed;inset:0;z-index:-1;pointer-events:none;background:radial-gradient(ellipse 42% 66% at -8% 44%,rgba(212,179,113,.23) 0%,rgba(212,179,113,.10) 45%,transparent 76%),radial-gradient(ellipse 42% 55% at 108% 62%,rgba(220,167,97,.16) 0%,rgba(184,137,69,.055) 47%,transparent 78%);}',
    '.product-grid,.aa-product-grid,.collection,.main-collection-grid,.aa-products-grid,.aa-home-products{position:relative;}',
    '.product-grid:before,.aa-product-grid:before,.collection:before,.main-collection-grid:before,.aa-products-grid:before,.aa-home-products:before{content:"";position:absolute;inset:-30px -42px;z-index:-1;border-radius:36px;background:radial-gradient(ellipse at 6% 34%,rgba(212,179,113,.12),transparent 38%),radial-gradient(ellipse at 95% 71%,rgba(222,176,105,.09),transparent 36%);filter:blur(10px);pointer-events:none;}',
    '.product-card,.aa-product-card,.product-grid .card,.collection .card{box-shadow:0 18px 38px rgba(0,0,0,.23),0 0 0 1px rgba(212,179,113,.07)!important;}'
  ].join('');
  document.head.appendChild(style);
});


document.addEventListener('DOMContentLoaded', function () {
  if(document.documentElement.dataset.aaVersion==='03')return;
  if (window.location.pathname !== '/pages/customize-tumbler') return;
  var effect = document.getElementById('aa-effect');
  var color = document.getElementById('aa-color');
  if (!effect || !color || effect.dataset.ashanartLavaPalette === 'true') return;
  effect.dataset.ashanartLavaPalette = 'true';
  var lavaColors = [
    'Rojo volcánico',
    'Naranja fuego',
    'Amarillo solar',
    'Ámbar dorado',
    'Coral brillante',
    'Rosa fucsia',
    'Rosa lava',
    'Magenta intenso',
    'Morado lava',
    'Violeta eléctrico',
    'Azul eléctrico',
    'Turquesa neón',
    'Verde lima',
    'Negro obsidiana',
    'Rojo vino',
    'Cobre metálico'
  ];
  function applyLavaColors() {
    if (effect.value !== 'Lava') return;
    color.innerHTML = lavaColors.map(function (name) {
      return '<option>' + name + '</option>';
    }).join('');
  }
  effect.addEventListener('change', function () {
    window.setTimeout(applyLavaColors, 0);
  });
  applyLavaColors();
});

document.addEventListener('DOMContentLoaded', function () {
  if(document.documentElement.dataset.aaVersion==='03')return;
  if (window.location.pathname !== '/pages/customize') return;
  var images = document.querySelectorAll('.aa-shop__card .aa-shop__visual img');
  var acrylic = 'https://cdn.shopify.com/s/files/1/1007/4901/7373/files/ashanart-customizer-16oz-v11.png?v=1792642774';
  var stainless = 'https://cdn.shopify.com/s/files/1/1007/4901/7373/files/a77c2560-35da-4160-a8b0-d01e18a72226.png?v=1791738942';
  images.forEach(function (image) {
    var card = image.closest('.aa-shop__card');
    var href = card ? card.getAttribute('href') || '' : '';
    if (href.indexOf('item=tumbler16') !== -1) image.src = acrylic;
    if (href.indexOf('item=uv') !== -1) image.src = stainless;
  });
});

(function () {
  function bindAshanartCardLinks() {
    var links = [
      {
        selector: '.aa-tumbler-reveal--20',
        url: '/pages/customize-tumbler?item=uv',
        label: 'Personalizar Stainless Steel Tumbler de 20 oz'
      },
      {
        selector: '.aa-tumbler-reveal--16',
        url: '/pages/customize-tumbler?item=tumbler16',
        label: 'Personalizar Acrylic Tumbler de 16 oz'
      }
    ];

    links.forEach(function (item) {
      var card = document.querySelector(item.selector);
      if (!card || card.tagName === 'A' || card.dataset.ashanartCardLink) return;

      var pressTimer = null;
      var skipClickUntil = 0;

      function reveal() {
        card.classList.add('is-revealed');
        card.setAttribute('aria-pressed', 'true');
        if (card.classList.contains('aa-tumbler-reveal--20')) {
          window.setTimeout(function () {
            if (card.classList.contains('is-revealed')) card.classList.add('is-second');
          }, 220);
        }
      }

      function reset() {
        card.classList.remove('is-revealed', 'is-second');
        card.setAttribute('aria-pressed', 'false');
      }

      card.dataset.ashanartCardLink = 'true';
      card.setAttribute('role', 'link');
      card.setAttribute('aria-label', item.label);
      card.setAttribute('aria-pressed', 'false');

      card.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
        pressTimer = window.setTimeout(function () {
          reveal();
          skipClickUntil = Date.now() + 650;
        }, 430);
      }, { passive: true });

      card.addEventListener('pointerup', function (event) {
        if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
        window.clearTimeout(pressTimer);
        if (Date.now() < skipClickUntil) window.setTimeout(reset, 1350);
      });

      card.addEventListener('pointercancel', function () {
        window.clearTimeout(pressTimer);
        reset();
      });

      card.addEventListener('click', function (event) {
        if (Date.now() < skipClickUntil) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        window.location.href = item.url;
      });

      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          window.location.href = item.url;
        }
        if (event.key === ' ') {
          event.preventDefault();
          reveal();
          window.setTimeout(reset, 1350);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAshanartCardLinks);
  } else {
    bindAshanartCardLinks();
  }
})();


